module.exports = __webpack_public_path__ + "static/scale-model-of-the-durham-museum-in-omaha-nebraska-b913f5c0990e0b60a0c03b17805f5166.png";